import React, { useEffect, useCallback, useState} from 'react';
import {isNumber} from "utils/IsNumber.js"
import {setParameterToMap} from "actions/index.js";
import {connect} from 'react-redux';

const ParameterInput = ({val, placeholder, parameter, className, isMacroMapping, setParameterToMap}) => { 
    let [value, setValue] = useState('');

    useEffect(() => {
        setValue(val);
    }, [val, setValue]);

    const onChange = useCallback((e) => {
        let value = e.target.value;
        if (value === '.' || value === '-.') {
            value = 0;
        } else if (value === '-') {
            value = 0;
        } else if (value === '') {
            value = 0;
        } else if (!isNumber(value)) {
            return;
        } else {
            value = parseFloat(value);
        }
        parameter.set(value);
        setValue(value);
    }, [setValue, parameter]);

    if (isMacroMapping) {
        className += " mapping";
    }

    const onClick = useCallback((e) => {
        if (isMacroMapping) {
            e.stopPropagation();
            e.preventDefault();
            if (!parameter.isMapped) {
                setParameterToMap(parameter);
            }
        }
    }, [isMacroMapping, parameter]);
    

    let id = "parameter-" + parameter.id;
    return (
        <input
          id={id}
          onClick={onClick}
          className={className}
          value={value}
          onChange={onChange}
          placeholder={placeholder}/>);
};

const mapStateToProps = (state, props) => {
  return {
      isMacroMapping: state.effects.isMacroMapping,
      val: props.parameter.get()
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
      setParameterToMap: parameter => dispatch(setParameterToMap(parameter)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ParameterInput);
